import { styled } from '@mui/material/styles';
import { COLORS } from '../../../../utils/colors';
import { Box, Button, Modal, Typography } from '@mui/material';

export const useDocumentTemplateStyles = () => {
  return {
    select: {
      width: '100%',
      borderRadius: '0.5rem',
      '& .MuiOutlinedInput-root': {
        padding: '.5rem',
      },
    },
    inputLabel: {
      fontSize: '1rem',
      backgroundColor: 'white',
      px: '.5rem',
    },
    planData: {
      border: `.0625rem solid ${COLORS.MEDIUM_GRAY}`,
      borderRadius: '.25rem',
      p: 0,
      height: 'calc(100% - 9rem)',
      display: 'flex',
      flexDirection: 'column',
    },
    buttonContainer: {
      mt: '1.25rem',
      display: 'flex',
      gap: '1rem',
      justifyContent: 'flex-end',
    },
  };
};

export const StyledModal = styled(Box)({
  position: 'absolute',
  top: '3.625rem',
  right: 0,
  height: 'min(calc(100vh - 4rem), 60rem)',
  width: '55%',
  backgroundColor: COLORS.WHITE,
  boxShadow: '0 2px 10px 0 rgba(0, 0, 0, 0.26)',
  padding: '1.125rem 1.4375rem',
});
